import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getChairTimeOverview,
  type ChairTimeOverviewResult,
} from '@services/api/dashboard/chair-time.api'

export function useChairTimeOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<ChairTimeOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getChairTimeOverview, {
    enabled,
    queued,
  })
}
